// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__11b9K","col":"styles_col__ILVho"};